import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-service-object',
  templateUrl: './service-object.component.html',
  styleUrls: ['./service-object.component.scss']
})
export class ServiceObjectComponent implements OnInit {
  active = 0;

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.active = Number(res.id);
    });
  }

  onChange(e): void {
    this.active = e;
  }
}
